import { type App, defineAsyncComponent } from 'vue'

const components = {
  DgBack: defineAsyncComponent(() => import('./DgBack.vue')),
  DgCrumbs: defineAsyncComponent(() => import('./DgCrumbs.vue')),
  DgFailure: defineAsyncComponent(() => import('./DgFailure.vue')),
  DgMobileNotice: defineAsyncComponent(() => import('./DgMobileNotice.vue')),
  DgPage: defineAsyncComponent(() => import('./DgPage.vue')),
  DgPreferences: defineAsyncComponent(() => import('./DgPreferences.vue')),
  LayoutPage: defineAsyncComponent(() => import('../pages/LayoutPage.vue')),
  WorkspaceSwitcher: defineAsyncComponent(() => import('./WorkspaceSwitcher.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
